import { faTag } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function DiscountTag({ discountPercent, className = '' }: { discountPercent: number | string, className?: string }) {
    return Number(discountPercent) > 0 && Number(discountPercent) < 100 && (
        <div className={`${className} bg-main-500 w-fit px-2 absolute top-2 left-2 py-1 max-w-fit
                         text-white rounded-lg text-xs flex items-center gap-1`
        }>
            <FontAwesomeIcon icon={faTag} />
            <span>{Math.floor(Number(discountPercent))}% off</span>
        </div>
    );
}